import { APP_INITIALIZER, inject, Provider } from '@angular/core';

import { LogRocketService } from './logrocket.service';

export function provideLogRocket(appId: string | undefined): Provider[] {
  return appId
    ? [
      {
        multi: true,
        provide: APP_INITIALIZER,
        useFactory: () => {
          const logRocketService = inject(LogRocketService);

          return () => logRocketService.initialize(appId);
        },
      },
    ]
    : [];
}
